import React from 'react';

const DEFAULT_IMAGE_SIZE = {
  width: 960,
  height: 540,
};

export const useImageSize = (imageUrl: string | undefined | null) => {
  const [imageSize, setImageSize] = React.useState({ width: 0, height: 0 });

  React.useEffect(() => {
    if (!imageUrl) {
      // set image size for placeholder image
      setImageSize(DEFAULT_IMAGE_SIZE);
      return;
    }

    const image = new Image();
    image.onload = function () {
      const { width, height } = image;
      const computedWidth =
        width > height
          ? DEFAULT_IMAGE_SIZE.width
          : (width / height) * DEFAULT_IMAGE_SIZE.height;
      const computedHeight =
        width > height
          ? (height / width) * DEFAULT_IMAGE_SIZE.width
          : DEFAULT_IMAGE_SIZE.height;
      setImageSize({ width: computedWidth, height: computedHeight });
    };
    image.src = imageUrl;
  }, [imageUrl]);

  return imageSize;
};
